import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import servePositionService from '../../services/servePositionService';
import { addNotification } from '../../store/slices/uiSlice';
import './ManagePositionsModal.css';

const ManagePositionsModal = ({ member, positions, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const [currentPositions, setCurrentPositions] = useState(
    member.positions?.filter(p => p.status === 'active') || []
  );
  const [saving, setSaving] = useState(false);

  // Get available positions (not already assigned)
  const availablePositions = positions.filter(
    p => p.is_active && !currentPositions.some(cp => cp.position_id === p.id)
  );

  const handleAddPosition = async (positionId) => {
    try {
      const assignmentData = {
        member_id: member.id,
        position_id: parseInt(positionId),
        status: 'active'
      };
      
      const newAssignment = await servePositionService.createAssignment(assignmentData);
      setCurrentPositions([...currentPositions, newAssignment]);
      
      dispatch(addNotification({
        type: 'success',
        message: '新增崗位成功'
      }));
    } catch (error) {
      console.error('Error adding position:', error);
      dispatch(addNotification({
        type: 'error',
        message: '新增崗位失敗'
      }));
    }
  };

  const handleRemovePosition = async (assignmentId) => {
    try {
      await servePositionService.deleteAssignment(assignmentId);
      setCurrentPositions(currentPositions.filter(p => p.id !== assignmentId));
      
      dispatch(addNotification({
        type: 'success',
        message: '移除崗位成功'
      }));
    } catch (error) {
      console.error('Error removing position:', error);
      dispatch(addNotification({
        type: 'error',
        message: '移除崗位失敗'
      }));
    }
  };

  const handleClose = () => {
    onSuccess();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content manage-positions-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>管理事奉崗位</h2>
          <button className="close-btn" onClick={handleClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="member-info">
            <div className="info-row">
              <span className="label">會員：</span>
              <span className="value">{member.chi_name}</span>
            </div>
            <div className="info-row">
              <span className="label">崇拜編碼：</span>
              <span className="value">{member.worship_id}</span>
            </div>
          </div>

          <div className="positions-section">
            <label className="section-label">現有崗位</label>
            <div className="positions-tags-container">
              {currentPositions.length > 0 ? (
                currentPositions.map(assignment => {
                  const position = positions.find(p => p.id === assignment.position_id);
                  return (
                    <div key={assignment.id} className="position-tag">
                      <span className="tag-name">{position?.position_name || '未知崗位'}</span>
                      <button
                        onClick={() => handleRemovePosition(assignment.id)}
                        className="tag-remove-btn"
                        title="移除崗位"
                      >
                        ×
                      </button>
                    </div>
                  );
                })
              ) : (
                <p className="empty-message">尚未分配任何崗位</p>
              )}
            </div>
          </div>

          {availablePositions.length > 0 && (
            <div className="add-position-section">
              <label className="section-label">新增崗位</label>
              <select
                onChange={(e) => {
                  if (e.target.value) {
                    handleAddPosition(e.target.value);
                  }
                }}
                value=""
                className="position-dropdown"
              >
                <option value="">選擇要新增的崗位...</option>
                {availablePositions.map(pos => (
                  <option key={pos.id} value={pos.id}>
                    {pos.position_name}
                    {pos.position_name_en && ` (${pos.position_name_en})`}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <p className="auto-save-note">更改會自動儲存</p>
          <button onClick={handleClose} className="btn-done">
            關閉
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManagePositionsModal;
